module.exports = __webpack_public_path__ + "img/screenshot_2.da469a7f.png";